import { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";
import "./css/PaymentChartToggle.css";




const PaymentChartToggle = ({ monthlyData, yearlyData, incomeExpenseData, incomeExpenseYearlyData }) => {
  const [view, setView] = useState("monthly");

  const chartData = view === "monthly" ? monthlyData : yearlyData;
  const incomeexpenseChartData = view === "monthly" ? incomeExpenseData : incomeExpenseYearlyData;
  const xKey = view === "monthly" ? "month" : "year";


  const totalIncome = incomeexpenseChartData.reduce((s, i) => s + i.income, 0);
  const totalExpense = incomeexpenseChartData.reduce((s, i) => s + i.expense, 0);


  return (
    <div className="chart-card">
      <div className="chart-header">
        <h3>Maintenance Collection</h3>

        <div className="toggle">
          <button
            className={view === "monthly" ? "active" : ""}
            onClick={() => setView("monthly")}
          >
            Monthly
          </button>
          <button
            className={view === "yearly" ? "active" : ""}
            onClick={() => setView("yearly")}
          >
            Yearly
          </button>
        </div>
      </div>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xKey} />
          <YAxis />
          <Tooltip />
          <Bar dataKey="amount" radius={[6, 6, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>

      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={incomeexpenseChartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={xKey} />
          <YAxis />
          <Tooltip />
          <Legend/>          
          <Bar dataKey="income" stackId="a" fill="#16a34a" />
          <Bar dataKey="expense" stackId="a" fill="#dc2626" />
        </BarChart>
      </ResponsiveContainer>


      <div className="summary">
        <div className="income">Income: ₹ {totalIncome}</div>
        <div className="expense">Expense: ₹ {totalExpense}</div>
        <div className="balance">Balance: ₹ {totalIncome - totalExpense}
        </div>
    </div>


    </div>
  );
};

export default PaymentChartToggle;
